import { render, staticRenderFns } from "./SelectReservationList.vue?vue&type=template&id=481782c8&scoped=true"
import script from "./SelectReservationList.vue?vue&type=script&lang=js"
export * from "./SelectReservationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481782c8",
  null
  
)

export default component.exports